import { HttpClient } from '@angular/common/http';
import { Base } from './base';
import { UserRounds } from './trading-vaults/user-rounds';
import { PoolSnapshots } from './trading-vaults/pool-snapshots';
import { Accounts } from './trading-vaults/accounts';
import { Rounds } from './trading-vaults/rounds';

export class TradingVaults extends Base {
  constructor(protected httpClient: HttpClient) {
    super(httpClient, 'trading_vaults');
  }

  of(id: string) {
    return {
      poolSnapshots: new PoolSnapshots(this.httpClient, this.pathJoin(id)),
      rounds: new Rounds(this.httpClient, this.pathJoin(id)),
      userRounds: new UserRounds(this.httpClient, this.pathJoin(id)),
      accounts: new Accounts(this.httpClient, this.pathJoin(id))
    };
  }
}
